import type { ColumnHeader } from "@/components/MyTable";

export const CONFLICTS_API_URL = "/aircall/unassigned-interactions";
export const INVALID_CONFLICTS_API_URL = "/aircall/invalid-interactions";
export const PATIENT_INTERACTIONS_API_URL = "/aircall/interactions";

/** Grace bot number used on behalf of the care team / caretaker. */
export const GRACE_BOT_PHONE_NUMBER = "+13072986351";

export const conflictTableHeaders: ColumnHeader[] = [
  { id: "date", label: "Date", isSortable: true },
  { id: "time", label: "Time", isSortable: false },
  { id: "phoneNumber", label: "Phone Number", isSortable: false },
  { id: "callType", label: "Call Type", isSortable: false },
  { id: "organizationName", label: "Organisation", isSortable: false },
  { id: "attachment", label: "Attachment", isSortable: false },
  { id: "transcript", label: "Transcript", isSortable: false },
];
